import React from "react";

import { SubHeader } from "clearsense-ui/components";

const PrimaryHeader = () => (
  <SubHeader
    className="mt-8 mb-2"
    breadcrumbs={[
      { label: "Datasets", link: "#" },
      { label: "Overview", link: "#" },
    ]}
  />
);

export default PrimaryHeader;
